<script lang="ts">
    import { onNavigate } from '$app/navigation'

    const LoginRouteId = '/(unauthenticated)/login'
    const LoginHelpRouteId = '/(public)/login/help'
    const LoginSupportRouteId = '/(public)/login/support'
    const MobileAuthEnterTransitionClass = 'auth-route-enter-transition'
    const MobileAuthExitTransitionClass = 'auth-route-exit-transition'
    const MobileAuthViewport = '(max-width: 899px)'
    const ReducedMotion = '(prefers-reduced-motion: reduce)'

    function canStartMobileHelpTransition(): boolean {
        return (
            'startViewTransition' in document &&
            window.matchMedia(MobileAuthViewport).matches &&
            !window.matchMedia(ReducedMotion).matches
        )
    }

    onNavigate((navigation) => {
        const transitionClass = getMobileHelpTransitionClass(
            navigation.from?.route.id,
            navigation.to?.route.id
        )

        if (!transitionClass || !canStartMobileHelpTransition()) {
            return
        }

        document.documentElement.classList.add(transitionClass)

        return new Promise<void>((resolve) => {
            const transition = document.startViewTransition(async () => {
                resolve()
                await navigation.complete
            })

            void transition.finished
                .finally(() => {
                    document.documentElement.classList.remove(transitionClass)
                })
                .catch(() => undefined)
        })
    })

    function getMobileHelpTransitionClass(
        fromRouteId: string | null | undefined,
        toRouteId: string | null | undefined
    ): string | undefined {
        if (
            (fromRouteId === LoginRouteId && toRouteId === LoginHelpRouteId) ||
            (fromRouteId === LoginHelpRouteId && toRouteId === LoginSupportRouteId)
        ) {
            return MobileAuthEnterTransitionClass
        }

        if (
            (fromRouteId === LoginHelpRouteId && toRouteId === LoginRouteId) ||
            (fromRouteId === LoginSupportRouteId && toRouteId === LoginHelpRouteId)
        ) {
            return MobileAuthExitTransitionClass
        }
    }
</script>
